import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import classNames from 'classnames';
import Input from './Input';
import { UXPContext } from "@core/context/Context";
import { FontAwesomeIconWrapper } from "@icon/fontawesome/FontAwesomeIconWrapper";
/**
 * A searchbox component
 * @export
 *
 * @category Inputs/Text
 */
const SearchBox = React.forwardRef((props, ref) => {
    // props
    const context = React.useContext(UXPContext);
    const { value, onChange, className, collapsed = false, position = 'left', placeholder = 'Search', autoFocus, minWidth, maxWidth, width, fullWidth, disabled, readOnly, isValid } = props;
    // state
    const [isExpanded, setIsExpanded] = React.useState(false);
    // ref
    const inputRef = React.useRef(null);
    React.useImperativeHandle(ref, () => ({
        focusInput: () => { var _a; return (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.focus(); },
        getInputElement: () => { var _a; return (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.getElement(); }
    }));
    // Auto-focus when expanding in collapsed mode
    React.useEffect(() => {
        var _a;
        if (collapsed && isExpanded) {
            (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        }
    }, [collapsed, isExpanded]);
    const handleWrapperClick = () => {
        if (collapsed && !isExpanded) {
            setIsExpanded(true);
        }
    };
    const handleBlur = () => {
        if (collapsed && isExpanded && !value) {
            setIsExpanded(false);
        }
    };
    // Input attributes
    let inputAttr = {};
    if (autoFocus)
        inputAttr = { autoFocus: true };
    // Close button for collapsed+expanded mode (collapses back to circle)
    const closeButton = (_jsx("div", { onClick: () => setIsExpanded(false), className: "uxpcore_searchbox__close-button", children: _jsx(FontAwesomeIconWrapper, { icon: ['fal', 'times'] }) }));
    // Clear button for normal mode (clears search text)
    const clearButton = value.length > 0 ? (_jsx("div", { onClick: () => onChange(""), className: "uxpcore_searchbox__clear-button", children: _jsx(FontAwesomeIconWrapper, { icon: ['fal', 'times'] }) })) : null;
    // Choose suffix based on mode
    const finalSuffix = (collapsed && isExpanded) ? closeButton : clearButton;
    // Wrapper div only needed for onClick in collapsed mode
    const input = (_jsx(Input, { onChange: onChange, value: value, className: classNames("uxpcore_searchbox", className, {
            "uxpcore_searchbox--collapsed": collapsed,
            "uxpcore_searchbox--expanded": collapsed && isExpanded,
            "uxpcore_searchbox--active": value.length > 0
        }), inputAttr: inputAttr, placeholder: placeholder, ref: inputRef, prefix: _jsx(FontAwesomeIconWrapper, { icon: ['fal', 'search'] }), suffix: finalSuffix, minWidth: !collapsed ? minWidth : undefined, maxWidth: !collapsed ? maxWidth : undefined, width: !collapsed ? width : undefined, fullWidth: !collapsed ? fullWidth : undefined, disabled: disabled, readOnly: readOnly, isValid: isValid, onBlur: handleBlur, hideClear: true }));
    // Wrap in clickable div only for collapsed mode
    if (collapsed) {
        return (_jsx("div", { onClick: handleWrapperClick, className: classNames("uxpcore_searchbox__wrapper", { "uxpcore_searchbox__wrapper--expanded": isExpanded }), children: input }));
    }
    return input;
});
SearchBox.displayName = 'SearchBox';
export default SearchBox;
